import { createContext, useContext, useState, useEffect } from 'react';

const SettingContext = createContext();


const FONTSIZES = {
    EXTRA_SMALL: 14,
    SMALL: 16,
    MEDIUM: 18,
    LARGE: 20,
    EXTRA_LARGE: 22,
}; 


export const SettingProvider = ({ children }) => {
  const [volume, setVolume] = useState(100);
  const [fontSize, setFontSize] = useState(FONTSIZES.MEDIUM);
  const updateFontSize = (size) => {
    if (Object.values(FONTSIZES).includes(size)) {
      setFontSize(size);
      localStorage.setItem('fontSize', size);
    }
  };
 
  const updateVolume = async (v) => {
    let volumeLevel = isNaN(Number(v)) ? 0 : Number(v);
    setVolume(volumeLevel);
    console.log("Volume updated to:", volumeLevel);
    //save volume to local storage
    localStorage.setItem('volume', volumeLevel);
  };

  useEffect(() => {
    const savedVolume = localStorage.getItem('volume');
    if (savedVolume) {
      setVolume(parseFloat(savedVolume));
      console.log("Saved volume found in local storage, updating volume state to:", savedVolume);
    }

    const savedFontSize = localStorage.getItem('fontSize');
    if (savedFontSize && Object.values(FONTSIZES).includes(Number(savedFontSize))) {
      setFontSize(Number(savedFontSize));
      console.log("Saved font size found in local storage, updating font size state to:", savedFontSize);
    }
  }, []);
  
  return (
    <SettingContext.Provider value={{ volume, updateVolume, fontSize, updateFontSize }}>
      {children}
    </SettingContext.Provider>
  );
};

export const useSetting = () => useContext(SettingContext);